import React from 'react';
import s from './AlgoliaMini.module.scss';
import {StaticImage} from 'gatsby-plugin-image';
import {AlgoliaSearch} from '../algolia-search/AlgoliaSearch.component';

interface IAlgoliaMini {
  isTopBarVisible?: boolean;
}

export const AlgoliaMini = ({isTopBarVisible}: IAlgoliaMini) => {

  return (
    <div className={`${s.algoliaMini} ${isTopBarVisible ? s.lowerAlgoliaMini : ''}`}>
      <div className={s.algoliaMini__imageWrapper}>
        <StaticImage
          alt={''}
          src={'../../../../assets/images/algolia-mini-bigger-bg.jpg'}
          className={s.algoliaMini__image}
        />
      </div>
      <div className={s.algoliaMini__search}>
        <AlgoliaSearch/>
      </div>
    </div>
  );
};
